import { createApp } from 'vue'
import { steps } from './data/steps'
import Step from './components/Step'
import ErrorLayer from './components/ErrorLayer'
import { findGetParameter } from '../common'
import { QuickOmeDb } from './QuickOmeDb'

(function () {
  const quickOme = document.getElementById('quickome')
  if (!quickOme) {
    return
  } else {
    quickOme.innerHTML = '<div v-if="progressPercent > 0">\n' +
      '            <div class="quickome__progress" title="">\n' +
      '                <div v-for="n in progressStepsCount" class="quickome__progress-item" :class="[(progressCurrentNumber == n ? \'quickome__progress-item--current\' : \'\'),(progressCurrentNumber > n ? \'quickome__progress-item--done\' : \'\')]"></div>\n' +
      '            </div>\n' +
      '        </div>\n' +
      '        <div v-if="loading">Loading...</div>\n' +
      '\n' +
      '        <error-layer\n' +
      '                :show="errorLayer.show"\n' +
      '                :title="errorLayer.title"\n' +
      '                :message="errorLayer.message"\n' +
      '                @button-clicked="closeErrorLayer"\n' +
      '        ></error-layer>\n' +
      '        <div class="quickome__steps">\n' +
      '            <div class="quickome__steps__inner">\n' +
      '                <step v-for="step in steps"\n' +
      '                      :key="step.id"\n' +
      '                      :step="step"\n' +
      '                      @go-to-next="goToNextStep"\n' +
      '                      @go-to-previous="goToPreviousStep"\n' +
      '                      :friend="savableData.friend"\n' +
      '                      :step-width="stepWidth"\n' +
      '                      :data="savableData.validatedFormData"\n' +
      '                />\n' +
      '            </div>\n' +
      '        </div>'
  }

  const db = new QuickOmeDb()

  let outerContainer = null

  createApp({
    data () {
      return {
        loading: true,
        errorLayer: {
          show: false,
          title: null,
          message: null
        },
        steps,
        savableData: {
          id: 1,
          currentStepId: 'step-1',
          stepHistory: ['step-1'], // stack | only use push and pop
          validatedFormData: {}, // {"step-x":{"inputName":"test value"}}'
          formSubmitted: false
        },
        stepWidth: 1132
      }
    },
    components: {
      Step,
      ErrorLayer
    },
    async mounted () {
      const deleteOldDb = findGetParameter('d') === '1'

      // friendship advertisement
      let friend = findGetParameter('friend')
      if (typeof friend !== 'string' || friend.length !== 64) {
        friend = null
      }

      await db.initDb(this.savableDataJson, deleteOldDb)

      if (deleteOldDb) {
        window.history.replaceState(
          null,
          '',
          `${window.location.pathname}`
        )
      }

      // init data
      this.savableData = await db.getQuickData()
      // console.debug('savableData', this.savableData)

      // update friend info
      this.savableData.friend = friend

      outerContainer = document.querySelector('.quickome__steps__inner')
      // set initial width
      this.setStepWidth()

      // set width on window resize event
      window.addEventListener('resize', this.onResize)

      // insert form values
      this.steps.forEach(step => {
        if (step.formComponent && step.formData && this.savableData.validatedFormData && this.savableData.validatedFormData[step.id]) {
          for (const key of Object.keys(this.savableData.validatedFormData[step.id])) {
            step.formData[key] = this.savableData.validatedFormData[step.id][key]
          }
        }
      })

      this.showStepHtmlAndHideOhters(this.savableData.currentStepId, true)
      this.loading = false

      this.pushMatomoDataLayer()

      // if page is reloaded on form was already submitted -> finished -> clear data and reload page
      // console.debug('this.savableData.formSubmitted', this.savableData.formSubmitted)
      if (this.savableData.formSubmitted === true) {
        this.clearLocalData()
        document.location.href = document.location.pathname
      }

      // window.submitData = this.submitData
    },
    unmounted () {
      window.removeEventListener('resize', this.setStepWidth)
    },
    computed: {
      progressStepsCount () {
        // without last steps (overview)
        return this.steps.length - 1
      },
      progressCurrentNumber () {
        return (this.steps.findIndex(step => step.id === this.savableData.currentStepId) + 1)
      },
      progressPercent () {
        return Math.ceil((this.progressCurrentNumber + 1) / this.progressStepsCount * 100)
      },
      savableDataJson () {
        // hs to be done like this, so that the reactivity is removed from the objects
        let dataToSave = JSON.parse(JSON.stringify(this.savableData))
        return dataToSave
      }
    },
    methods: {
      setStepWidth () {
        if (outerContainer !== null) {
          // console.debug('setStepWidth', outerContainer, outerContainer.clientWidth)
          this.stepWidth = outerContainer.clientWidth
        }
      },
      onResize () {
        this.setStepWidth()
        this.showStepHtmlAndHideOhters(this.savableData.currentStepId)
      },
      async goToPreviousStep () {
        const currentStepId = this.savableData.stepHistory[this.savableData.stepHistory.length - 1]

        // no previous step
        if (currentStepId === undefined) {
          return
        }

        // not in sync
        if (currentStepId !== this.savableData.currentStepId) {
          return
        }

        const previousStepId = this.savableData.stepHistory[this.savableData.stepHistory.length - 2]

        // find previous step
        const previousStep = this.findStep(previousStepId)
        if (!previousStep) {
          return
        }

        // find previous step html
        const previousStepElement = document.getElementById(previousStep.id)
        if (!previousStepElement) {
          return
        }

        this.savableData.stepHistory.pop()
        this.savableData.currentStepId = previousStepId
        this.debugLogSteps()
        this.pushMatomoDataLayer()
        await this.saveLocalData()
        this.showStepHtmlAndHideOhters(previousStepId, true)
      },

      async goToNextStep () {
        const p = new Promise(async (resolve, reject) => {
          // find current step
          const currentStep = this.findStep(this.savableData.currentStepId)

          if (!currentStep) {
            reject(new Error(`Current step with id:  ${this.savableData.currentStepId} not found`))
            return
          }

          // save form data
          if (currentStep.formComponent && currentStep.formData && currentStep !== 'summary') {
            // form is already validated before this method is called
            // so all inputs are valid
            this.savableData.validatedFormData[currentStep.id] = {}

            for (const key of Object.keys(currentStep.formData)) {
              if (currentStep.validatedFormDataIgnore && currentStep.validatedFormDataIgnore.includes(key)) {
                continue
              }

              if (currentStep.formData[key] !== undefined && currentStep.formData[key] !== null && currentStep.formData[key] !== '') {
                this.savableData.validatedFormData[currentStep.id][key] = currentStep.formData[key]
              }
            }
            await this.saveLocalData()
          }

          if (currentStep.isLast === true) {
            await this.clearAndGoToHomepage()
            resolve('last step - clear and go to home page')
            return
          }

          if (currentStep.possibleNextSteps && Array.isArray(currentStep.possibleNextSteps)) {
            for (let possibleNextStep of currentStep.possibleNextSteps) {
              const conditionExists = possibleNextStep.conditionFunc !== undefined && typeof possibleNextStep.conditionFunc === 'function'
              // console.debug('conditionExists', conditionExists, possibleNextStep.id)

              // no condition OR (condition exists and condition met)
              if (!conditionExists || (conditionExists && possibleNextStep.conditionFunc(this.savableData.validatedFormData[currentStep.id]))) {
                // get next step if exists (id)
                const nextStep = this.findStep(possibleNextStep.id)

                // next step found
                if (nextStep) {
                  let finallyGoToNextStep = true

                  if (possibleNextStep.doBeforeGoToNextStep && possibleNextStep.doBeforeGoToNextStep === 'submit') {
                    finallyGoToNextStep = false
                    await this.submitData()
                      .then(() => {
                        finallyGoToNextStep = true
                      })
                      .catch(err => console.error(err))
                  }

                  if (finallyGoToNextStep === false) {
                    continue
                  }

                  this.savableData.currentStepId = nextStep.id
                  this.savableData.stepHistory.push(this.savableData.currentStepId)
                  await this.saveLocalData()
                  this.debugLogSteps()
                  this.pushMatomoDataLayer()
                  this.showStepHtmlAndHideOhters(this.savableData.currentStepId, true)
                  resolve(nextStep)
                  return
                }
              }
            }
          }
          reject(new Error('No possible next step!'))
        })

        return p
      },

      showStepHtmlAndHideOhters (id, scrollToTop = false) {
        let currentIndex = -1
        this.steps.forEach((step) => {
          currentIndex++

          // show step
          if (step.id === id) {
            // console.debug('currentIndex', currentIndex)
            const foo = currentIndex * this.stepWidth * (-1)
            document.querySelector('.quickome__steps__inner').style.transform = 'translateX(' + foo + 'px)'
            step.visible = true

            // scroll to top
            if (scrollToTop === true) {
              setTimeout(() => {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })
              }, 300)
            }
          }

          // hide other steps if they are not already hidden
          else {
            step.visible = false
          }
        })
      },
      async submitData () {
        return new Promise(async (resolve, reject) => {
          this.loading = true

          let formData = {
            _labels: {}
          }
          for (const stepId of Object.keys(this.savableData.validatedFormData)) {
            // only send relevant data depending on the step history, the forms the user has finally filled
            if (!this.savableData.stepHistory.includes(stepId)) {
              continue
            }

            const currentStep = this.findStep(stepId)
            if (!currentStep) {
              continue
            }

            for (const inputName in this.savableData.validatedFormData[stepId]) {
              let value = this.savableData.validatedFormData[stepId][inputName]
              if (typeof value === 'boolean') {
                value = value === true ? '1' : '0'
              }
              formData[inputName] = value
              formData._labels[inputName] = currentStep.formLabels?.[inputName] || 'N/A'
            }

            if (this.savableData.friend) {
              formData.friend = this.savableData.friend
              // add a label for the friend
              formData._labels.friend = 'Freund:in / Weiterempfehlung'
            }
          }

          const url = '/?type=1452982684'
          const options = {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(formData)
          }

          const response = await fetch(url, options)
          this.loading = false
          if (response.ok) { // if HTTP-status is 200-299
            // get the response body (see below)
            this.savableData.formSubmitted = true
            await this.saveLocalData()
            resolve()
          } else {
            let json = await response.json()
            this.openErrorLayer()
            reject(json.message)
          }
        })
      },

      debugLogSteps () {
        console.debug('currentStep', this.savableData.currentStepId)
        console.debug('stepHistory', this.savableData.stepHistory)
        console.debug('validatedFormData', this.savableData.validatedFormData)
      },

      pushMatomoDataLayer() {
        const _paq = window._paq = window._paq || []

        // console.debug('step:',this.savableData.currentStepId.substring(5))

        _paq.push([
          'trackEvent',
          'KurzOME',
          'Step',
          this.savableData.currentStepId.substring(5)
        ])
      },

      async saveLocalData () {
        await db.updateData(this.savableDataJson)
      },

      clearLocalData () {
        db.delete()
      },

      clearAndGoToHomepage () {
        this.clearLocalData()
        location.href = '/'
      },
      findStep (id) {
        return steps.find(currStep => currStep.id === id)
      },
      openErrorLayer () {
        this.errorLayer.show = true
      },
      async closeErrorLayer (clearAndGoToHomepage = true) {
        this.errorLayer.show = false

        if (clearAndGoToHomepage) {
          await this.clearAndGoToHomepage()
        }
      }
    }
  }).mount('#quickome')
})()
